export type IntegrationScenarioIcon = 'card' | 'globe';

export type IntegrationScenarioMethod = 'card' | 'apm';

export type IntegrationScenarioTransactionType = 'pay-in' | 'pay-out';

export type IntegrationScenario = {
  id: string;
  transactionType: IntegrationScenarioTransactionType;
  title: string;
  description: string;
  method: IntegrationScenarioMethod;
  geo: string;
  currencies: string[];
  tags: string[];
  icon: IntegrationScenarioIcon;
};

/** Source: integrations spreadsheet (landing content). */
export const INTEGRATION_SCENARIOS: IntegrationScenario[] = [
  {
    id: 'sbp-pay-in',
    transactionType: 'pay-in',
    title: 'SBP pay in',
    description:
      'Enable your customers to pay the way they prefer. Skip the card details: payments are completed instantly via QR code or a direct link. Optimized for mobile traffic and physical retail locations.',
    method: 'card',
    geo: 'RUS',
    currencies: ['RUB'],
    tags: [],
    icon: 'card',
  },
  {
    id: 'morocco-pay-in',
    transactionType: 'pay-in',
    title: 'Morocco pay-in',
    description:
      'Integrate the leading alternative payment method in Morocco. With our API, you get a frictionless checkout process designed to drive maximum mobile conversions.',
    method: 'card',
    geo: 'Morocco',
    currencies: ['MAD'],
    tags: [],
    icon: 'card',
  },
  {
    id: 'morocco-pay-out',
    transactionType: 'pay-out',
    title: 'Morocco pay-out',
    description: 'Scale your operations in North Africa with Morocco’s leading financial network.',
    method: 'apm',
    geo: 'Morocco',
    currencies: ['MAD'],
    tags: [],
    icon: 'globe',
  },
  {
    id: 'eur-ecom',
    transactionType: 'pay-in',
    title: 'EUR e-com',
    description:
      'Expand your reach across Europe and beyond with our comprehensive EUR acquiring solution. Provide your customers with a localized checkout experience using the most trusted payment methods in the Eurozone.',
    method: 'card',
    geo: 'EU',
    currencies: ['EUR'],
    tags: ['Visa', 'Mastercard'],
    icon: 'card',
  },
  {
    id: 'eur-apple-pay',
    transactionType: 'pay-in',
    title: 'EUR Apple Pay',
    description:
      'Unlock the full potential of the European market with Apple Pay. Provide your customers with a frictionless, secure, and instant way to pay in Euros using their favorite devices.',
    method: 'apm',
    geo: 'EU',
    currencies: ['EUR'],
    tags: ['Apple Pay'],
    icon: 'globe',
  },
  {
    id: 'eur-google-pay',
    transactionType: 'pay-in',
    title: 'EUR Google Pay',
    description:
      'Reach millions of customers across the Eurozone by integrating Google Pay. Offer a fast, simple, and secure checkout experience that allows users to pay in Euros using the cards already stored in their Google accounts.',
    method: 'apm',
    geo: 'EU',
    currencies: ['EUR'],
    tags: ['Google Pay'],
    icon: 'globe',
  },
  {
    id: 'eur-open-banking',
    transactionType: 'pay-in',
    title: 'EUR Open Banking',
    description:
      'Leverage the power of PSD2 with our Open Banking integration. Enable your customers to pay directly from their bank accounts across the UK and EU, combining the cost-efficiency of bank transfers with the speed of digital commerce.',
    method: 'card',
    geo: 'EU',
    currencies: ['EUR'],
    tags: ['Open Banking'],
    icon: 'card',
  },
  {
    id: 'rub-pay-out-card',
    transactionType: 'pay-out',
    title: 'RUB Pay-out to card',
    description:
      'Optimize your business operations with our automated payout solution for the Russian market. Send funds to debit and credit cards issued by any Russian bank (Visa, Mastercard, MIR) with maximum speed and reliability.',
    method: 'card',
    geo: 'RUS',
    currencies: ['RUB'],
    tags: [],
    icon: 'card',
  },
  {
    id: 'usd-e-com',
    transactionType: 'pay-in',
    title: 'USD e-com',
    description:
      'Expand your reach worldwide with our comprehensive USD acquiring solution. Give your customers a smooth checkout with the most trusted card payment methods on a global scale.',
    method: 'card',
    geo: 'WW',
    currencies: ['USD'],
    tags: ['Visa', 'Mastercard'],
    icon: 'card',
  },
  {
    id: 'usd-google-pay',
    transactionType: 'pay-in',
    title: 'USD Google Pay',
    description:
      'Reach customers globally with Google Pay: a fast, simple, and secure checkout that lets users pay in US dollars using cards already saved in their Google accounts.',
    method: 'apm',
    geo: 'WW',
    currencies: ['USD'],
    tags: ['Google Pay'],
    icon: 'globe',
  },
  {
    id: 'usd-apple-pay',
    transactionType: 'pay-in',
    title: 'USD Apple Pay',
    description:
      'Offer Apple Pay for US dollar payments: a frictionless, secure experience on iPhone, Apple Watch, and compatible devices for customers around the world.',
    method: 'apm',
    geo: 'WW',
    currencies: ['USD'],
    tags: ['Apple Pay'],
    icon: 'globe',
  },
];
